import React from 'react'

const EditBodyIcon = () => {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.25"
        width="18.5"
        height="16.197"
        rx="4.75"
        fill="#F2F3F5"
        stroke="#DBDADE"
        strokeWidth="0.5"
      />
      <g clipPath="url(#clip0_1322_57094)">
        <path
          d="M12.2831 9.66203V11.7117C12.2831 11.9153 12.2022 12.1106 12.0583 12.2546C11.9143 12.3985 11.719 12.4794 11.5154 12.4794H6.1417C5.9381 12.4794 5.74284 12.3985 5.59887 12.2546C5.4549 12.1106 5.37402 11.9153 5.37402 11.7117V6.33799C5.37402 6.13439 5.4549 5.93913 5.59887 5.79516C5.74284 5.65119 5.9381 5.57031 6.1417 5.57031H8.1914"
          stroke="black"
        />
        <path
          d="M11.5151 4.79688L13.0505 6.33223L9.21211 10.1706H7.67676V8.63526L11.5151 4.79688Z"
          stroke="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1322_57094">
          <rect
            width="9.21212"
            height="9.21212"
            fill="white"
            transform="translate(4.60645 4.03125)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default EditBodyIcon
